<template>
  <transition name="modal">
    <div class="modal-mask max-w-full flex justify-center items-center">


<svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 75 75"
              class="spinner spinner-bg w-24 h-24"
              v-show="showSpinner"
            >
              <path
                d="M31.42,2.58c0,.25,0,.5,0,.73s.2.47.22.71.07.49.1.72-.07.5,0,.73.15.48.18.71.09.49.11.72.06.49.09.72.05.48.08.72,0,.48,0,.72,0,.48.05.72.22.45.26.7,0,.47,0,.72,0,.47,0,.73.17.45.2.7.07.47.1.72-.08.48-.05.73.16.47.18.72"
                style="fill: none;"
              ></path>
              <path
                d="M17.09,8.19c.15.21.34.38.47.57s.2.49.34.68l.43.61c.15.21.33.39.46.58s.25.45.39.64.27.43.41.62.37.34.51.54.29.39.44.59.21.45.36.66.33.35.48.56l.44.59c.14.19.27.4.42.61s.27.4.42.62.24.42.39.63"
                style="fill: none;"
              ></path>
              <path
                d="M5.51,19.76c.21.13.44.2.64.32l.61.35c.2.12.4.25.6.36s.44.19.64.3l.59.38c.22.12.45.17.65.28s.35.35.55.45l.63.32c.21.11.45.17.66.26s.4.26.61.34.42.21.64.29.48,0,.7.11l.68.19c.22.06.41.22.65.27s.46,0,.7.08l.69.11"
                style="fill: none;"
              ></path>
              <path
                d="M2.67,35.29c.24,0,.47-.09.7-.09s.48-.12.7-.12.49.15.71.15.48,0,.7,0,.49,0,.71,0,.48-.06.7-.06h1.4c.24,0,.47-.07.7-.06l.7,0c.22,0,.45-.08.7-.08s.45.15.7.14h.7c.22,0,.45-.07.7-.07s.46.06.7.06.47,0,.71,0"
                style="fill: none;"
              ></path>
              <path
                d="M5.35,50.86c.22-.1.48-.12.7-.22s.4-.28.62-.39.39-.29.61-.4.47-.12.69-.23.46-.15.68-.25.4-.28.61-.39.39-.3.61-.41.51-.06.72-.17.45-.18.66-.28.42-.24.63-.35.41-.27.62-.38l.64-.35.63-.33c.22-.12.4-.3.6-.42s.44-.22.64-.34.38-.33.56-.45.52-.16.67-.29.46-.45.44-.58"
                style="fill: none;"
              ></path>
              <path
                d="M23.62,51.5c-.13.21-.33.36-.45.56l-.38.59c-.13.21-.24.42-.36.61s-.23.42-.35.61-.23.42-.35.61-.33.36-.45.55-.19.45-.31.64-.18.45-.3.64-.33.35-.45.55-.3.35-.43.55-.18.43-.31.63-.16.44-.29.65-.38.29-.51.5-.28.37-.41.58-.22.4-.35.6-.2.42-.32.63l-.37.6-.38.6"
                style="fill: none;"
              ></path>
              <path
                d="M35.88,64c0-.25-.05-.48-.08-.71s-.13-.47-.16-.7,0-.48-.06-.7,0-.49,0-.71-.14-.48-.17-.7,0-.49,0-.71,0-.48-.05-.71-.07-.47-.09-.7-.08-.46-.1-.7-.08-.45-.11-.69,0-.47,0-.72-.13-.44-.16-.69-.14-.44-.17-.69,0-.47,0-.71,0-.47,0-.71-.13-.46-.16-.7"
                style="fill: none;"
              ></path>
              <path
                d="M44.89,50.57c.15.2.38.33.52.5s.31.38.45.56.27.41.42.58.27.41.41.59l.45.55c.16.2.34.35.49.53l.43.56c.15.18.28.38.43.57s.34.32.49.51.24.4.4.59.28.37.44.56l.45.55c.14.17.31.35.46.54s.31.35.47.55"
                style="fill: none;"
              ></path>
              <path
                d="M51.69,42.34c.23.1.49.12.7.21s.48.12.69.21.37.38.58.47.47.15.68.24.44.21.65.29.5.07.72.15l.66.26c.23.09.43.23.64.32s.42.24.64.33l.66.26c.21.09.46.11.69.2s.42.2.65.29.41.21.64.31.47.09.7.19.39.26.62.35l.66.29c.21.09.44.16.67.26"
                style="fill: none;"
              ></path>
              <path
                d="M52.79,31.7c.25,0,.49.06.73,0s.49-.08.72-.09.49-.09.71-.11.5-.07.72-.08.51.09.74.08.48-.12.71-.14.48-.1.72-.12.49.18.73.16.47-.07.71-.09.47,0,.72,0,.45-.17.71-.19.46-.05.71-.06.47,0,.73,0,.47,0,.72,0l.72,0c.23,0,.47-.1.72-.11"
                style="fill: none;"
              ></path>
              <path
                d="M50.87,23.37c.24-.1.51-.09.72-.19s.41-.29.62-.39.49-.15.7-.24.43-.26.64-.36l.65-.32c.24-.11.48-.15.69-.25s.43-.25.64-.35.41-.26.63-.36.41-.24.64-.35.47-.1.7-.21.39-.27.63-.38.4-.25.63-.36.5,0,.73-.14.42-.23.65-.34.44-.18.67-.29"
                style="fill: none;"
              ></path>
              <path
                d="M48.62,6.11c-.11.22-.17.46-.27.67s-.24.42-.34.62-.19.45-.29.65-.18.46-.27.66-.18.45-.28.65-.34.38-.43.59-.11.48-.21.68-.27.4-.37.61-.15.45-.25.66-.18.42-.29.64-.26.39-.37.61-.15.43-.26.66-.14.44-.25.66-.17.43-.27.65-.31.36-.42.58-.14.45-.25.68-.15.44-.26.67"
                style="fill: none;"
              ></path>
            </svg>
<transition name="modal">
      <div class="flex"  v-show="show">
        <div
          class="prev w-24 hidden md:flex justify-center items-center aboslute left-0 top-0 md:relative"
          v-if="prev != false"
        >
          <router-link :to="'/gallery/' + prev.id"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24.963"
              height="45.684"
              viewBox="0 0 24.963 45.684"
            >
              <path
                id="prev"
                data-name="Path 83"
                d="M297.323,14109l-21.781,21.781,21.781,21.781"
                transform="translate(-273.42 -14107.939)"
                fill="none"
                stroke="#ff3c39"
                stroke-width="3"
              />
            </svg>
          </router-link>
        </div>
        <div
          class="modal-container bg-pink-100 rounded-12 mx-auto my-auto rounded-md"
          @click.stop
        >
          <div class="modal-body flex justify-center relative " 
 
          >
            
            <img
              :src="
                'https://api.caseyhouse.com/sendyourlove/assets/' +
                  current.image.private_hash +
                  '?key=medium'
              "
              v-if="current !== false"
              class="galleryfullsize bg-white rounded-md border-pink-100 border-solid border-2 mx-0 z-10"
              :width="current.image.width"
              :height="current.image.height"
              @load="onImgLoad"
              v-touch:swipe.right="swipeLeft" 
              v-touch:swipe.left="swipeRight" 
            />
          </div>
          <div
            class="modal-footer pb-8 mt-auto flex flex-wrap justify-between lg:w-full p-4 text-md"
          >
            <div v-if='current.artist!="Anonymous"'><nobr>Sent with love by&nbsp;</nobr><br class="md:hidden">{{current.artist}}</div>
            <div v-else>Sent with love</div>
            <!-- <div><a href="">Share with a friend</a></div> -->
            <Twitter v-if="current.artist"
              :url="'https://love.caseyhouse.com/gallery/' + this.$route.params.id"
              :title="'Sent with love by ' + current.artist"
              :name="name"
              description="Send Your Love : Casey House. See more at love.caseyhouse.com"
              quote=" "

            />
          </div>
          <button class="close text-3xl z-20 " @click="close">&times;</button>
        </div>
        <div
          class="next w-24 hidden md:flex justify-center items-center"
          v-if="next != false"
        >
          <router-link :to="'/gallery/' + next.id" class="no-underline">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24.963"
              height="45.684"
              viewBox="0 0 24.963 45.684"
            >
              <path
                id="next"
                d="M297.323,14109l-21.781,21.781,21.781,21.781"
                transform="translate(298.383 14153.623) rotate(180)"
                fill="none"
                stroke="#ff3c39"
                stroke-width="3"
              />
            </svg>
          </router-link>
        </div>
      </div>
      </transition>
    </div>
  </transition>
</template>

<script>
// import GalleryModal from "@/components/GalleryModal.vue";
import Axios from "axios";
// import VueSocialSharing from 'vue-social-sharing';
import Twitter from "@/components/Twitter.vue";

export default {
  components: { Twitter },
  data() {
    return {
      id: false,
      current: false,
      name: "",
      show: false,
      //   sort: false,
      next: false,
      prev: false,
      showSpinner:false
      //   obj:false
    };
  },
  props: ["obj"],
  watch: {
    "$route.params.id": function(newQuestion, oldQuestion) {
      this.fetchData();

      //
      //   console.log('changed');
    },
    id(newval, oldval) {
      // console.log("hi");
      this.fetchData();
    },
    current(nc, oc) {
      // console.log("old", oc);
      // console.log("new", nc);
      this.$forceUpdate();
    },
  },
  updated() {
    // console.log("updated");
    // this.fetchData();
    // this.$forceUpdate();
    // this.drawMap()
  },
  mounted() {
    // console.log("obj", this.obj);
    this.fetchData();
  },
  methods: {
    swipeLeft(){
      // console.log("hi");
      if (this.next) {
        this.$router.push("/gallery/"+this.prev.id);
      }
    },
    swipeRight(){
      if (this.next) {
        this.$router.push("/gallery/"+this.next.id);        
      }
    },
    onImgLoad(){
      this.show=true;
      this.showSpinner=false;
    },
    fetchNextPrev() {
      //   console.log("objectsort", this.sort, this.heart.sort);
      //NEXT
      Axios.get(
        "https://api.caseyhouse.com/sendyourlove/items/hearts?fields=id,sort,image.private_hash,image.height,image.width,&single=1&sort=+sort&filter[sort][gt]=" +
          this.current.sort
      )
        .then((response) => {
          this.next = response.data.data;
          //PRELOAD NEXT AND PREV
          var img = new Image();
          img.src =
            "https://api.caseyhouse.com/sendyourlove/assets/" +
            this.next.image.private_hash +
            "?key=medium";
        })
        .catch(function(error) {});
      //PREV
      Axios.get(
        "https://api.caseyhouse.com/sendyourlove/items/hearts?fields=id,sort,image.private_hash,image.height,image.width,&single=1&sort=-sort&filter[sort][lt]=" +
          this.current.sort
      )
        .then((response) => {
          this.prev = response.data.data;
          var img = new Image();
          img.src =
            "https://api.caseyhouse.com/sendyourlove/assets/" +
            this.prev.image.private_hash +
            "?key=medium";
        })
        .catch(function(error) {});
    },
    fetchData() {
      this.showSpinner = true;
      Axios.get(
        "https://api.caseyhouse.com/sendyourlove/items/hearts/" +
          this.$route.params.id +
          "?fields=anonymous,id,sort,artist,image.private_hash,image.height,image.width"
      )
        .then((response) => {
          // console.log("fetced data");
          this.current = response.data.data;
          // console.log(this.current);
          this.fetchNextPrev();
        })
        .catch();
    },
    close() {
      this.$router.push("/gallery");
    },
  },
};
</script>

<style lang="css" scoped>


img.galleryfullsize {
  /* max-height: calc(100vh - 15rem); */
  /* max-width: calc(100%); */
  /* height:100%; */
  /* width:auto; */
  object-fit: scale-down;
  /* height: 100%; */
  height:auto;
  width:100%;
  max-width: 85vMin;
  max-height: 85vMin;
}

.spinner-bg {
  position: absolute;
  top: calc(50% - 3rem);
  left: calc(50% - 3rem);
  /* z-index: -1; */
  opacity: .9;
  /* transform: translate(-50%,-50%); */
}

* {
  box-sizing: border-box;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 1rem;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.85);
  transition: opacity 0.3s ease;
}

.modal-container {
  position: relative;
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
}

.text-right {
  text-align: right;
}

.form-label {
  display: block;
  margin-bottom: 1em;
}

.form-label > .form-control {
  margin-top: 0.5em;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: 1px solid #ddd;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
